import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../common/services/auth.service'
import { Router } from '@angular/router'
import { BreadcrumbService } from '../../../common/services/breadcrumb.service'

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router, private breadCrumbService: BreadcrumbService) {}

  ngOnInit() {
    this.breadCrumbService.reset();
    this.authService.logout()
    this.router.navigate(['/login'])
  }
}
